import firebase from 'firebase/app';
import { database } from '../config';
import ErrorLog from './error';
const Error = new ErrorLog()

export default class Usuario {
    constructor() {
        this.Activo = true
        this.Nombre = ''
        this.Apellido = ''
        this.Email = ''
        this.Direccion = ''
        this.Puntos = 0
    }

    getUserLogged() {
        return new Promise((resolve, reject) => {
            const unsubscribe = firebase.auth().onAuthStateChanged(user => {
                unsubscribe()
                resolve(user)
            }, reject)
        })
    }

    isUserAdmin(user) {
        return new Promise((resolve, reject) => {
            if (!user) resolve(false)

            let docRef = database.collection("usuarios").doc(user.uid)
            docRef.get()
                .then(doc => {
                    !doc.exists && resolve(false)
                    resolve(doc.data().IsAdmin)
                })
                .catch(error => Error.guardarError(error))
        })
    }

    getUsers() {
        return new Promise((resolve, reject) => {
            database.collection("usuarios")
                .get()
                .then(querySnapshot => resolve(querySnapshot.docs))
                .catch(error => reject(Error.guardarError(error)))
        })
    }

    leerUsuario(uid) {
        return new Promise((resolve, reject) => {
            database.collection("usuarios")
                .doc(uid)
                .get()
                .then(doc => resolve(doc.data()))
                .catch(error => reject(Error.guardarError(error)))
        })
    }

    buscarUsuario(correo){
        return new Promise((resolve, reject) => 
            database.collection('usuarios')
            .where('Correo', '>=', correo)
            .onSnapshot(querySnapshot => {
                let result = []

                querySnapshot.docs.forEach(doc => {
                    if (doc.data().Correo.includes(correo.toLowerCase())) {
                        result.push(doc)
                    }
                })

                if(result.length === 0 ){
                    this.buscarUsuarioNombre(correo)
                    .then(lista => resolve(lista))
                    .catch(error => reject(error))
                }

                resolve(result)
            }),(error => Error.guardarError(error))
        )
    }

    buscarUsuarioNombre(query){
        return new Promise((resolve, reject) => 
            database.collection('usuarios')
            .where('Nombre', 'array-contains', query)
            .where('Nombre', '>=', query)
            .where('Nombre', '<=', query)
            .onSnapshot(querySnapshot => {
                let result = []
                console.log(querySnapshot.docs)
                querySnapshot.docs.forEach(doc => {
                    if (doc.data().Nombre.includes(query.toLowerCase())) {
                        result.push(doc)
                    }
                })

                resolve(result)
            }),(error => Error.guardarError(error))
        )
    }

    guardarUsuario(user) {
        return new Promise((resolve, reject) => {
            database.collection("usuarios")
                .doc(user.uid)
                .set(user, {merge: true})
                .then(result => resolve(result))
                .catch(error => reject(Error.guardarError(error)))
        })
    }

    sumarPuntos(usuario, nuevoPuntaje) {
        const user = {
            ...usuario,
            Puntos: parseInt(usuario.Puntos) + parseInt(nuevoPuntaje)
        }

        return new Promise((resolve, reject) =>{
            this.guardarUsuario(user)
            .then(result => resolve(result))
            .catch(error => reject(Error.guardarError(error)))
        }) 
    }

    restarPuntos(usuario, nuevoPuntaje){
        const user = {
            ...usuario,
            Puntos: parseInt(usuario.Puntos) - parseInt(nuevoPuntaje)
        }

        return new Promise((resolve, reject) =>{
            this.guardarUsuario(user)
            .then(result => resolve(result))
            .catch(error => reject(Error.guardarError(error)))
        }) 
    }

}